var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box" }, [
    _c("div", { staticClass: "box1" }, [
      _c("img", {
        attrs: { src: require("../../assets/image/end.png"), alt: "" },
      }),
      _c("div", [_c("h1", [_vm._v(_vm._s(_vm.headline) + "!")])]),
    ]),
    _c(
      "div",
      { staticClass: "box-btn" },
      [
        _c(
          "van-button",
          { attrs: { round: "", type: "info" }, on: { click: _vm.routeClick } },
          [_vm._v("返回")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }